import { JsonProperty } from "../requests/jsonparser";
import { BPMPlaylistCategory } from "./bpmplaylist_category";
import { BPMPlaylist } from "./bpmplaylist";

export class BPMPlaylistResponse {

    @JsonProperty({ type: 'true' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'BPMPlaylistResponse' })
    MODELNAME: string;

    @JsonProperty({ clazz: BPMPlaylistCategory, type: 'BPMPlaylistCategory' })
    categories: BPMPlaylistCategory[]

    @JsonProperty({ clazz: BPMPlaylist, type: 'BPMPlaylist' })
    featured: BPMPlaylist[]
}



// WEBPACK FOOTER //
// ./src/api/src/models/bpmplaylist_response.ts